export const EDIT_SUCCESS = 'Cкидка обновлена';
export const EDIT_ERROR = 'Не удалось обновить скидку';
